import React, { useState, useEffect, useRef } from "react";
import * as S from "./styles";
import { Link } from "react-router-dom";
import * as API from "../../api";
import {
  DELAY_BUSCADOR_USUARIOS,
  USUARIOS_POR_PAGINA,
  TITULOS_COLUMNAS_USUARIOS,
} from "../../constants";
import { Loading } from "../../components/Loading";
import { FilterRow } from "../../components/FilterRow";
import { Sort } from "../../components/Sort";
import { Button } from "../../components/Button";
import { usePermissions } from "../../context/PermissionsContext";

export const Usuarios = () => {
  const [loading, setLoading] = useState(true);
  const { permissions } = usePermissions();
  const [loadingCount, setLoadingCount] = useState(true);
  const [usuarios, setUsuarios] = useState([]);
  const [pages, setPages] = useState(1);
  const [countUsuarios, setCountUsuarios] = useState(0);
  const [allShowed, setAllShowed] = useState(false);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [mainFilter, setMainFilter] = useState("todos-los-usuarios");
  const [openedFilter, setOpenedFilter] = useState(false);
  const [selectableFilters, setSelectableFilters] = useState([]);
  const [filters, setFilters] = useState([{ FilterId: "", FilterValue: "" }]);
  const [sortActive, setSortActive] = useState({});
  const delayTimer = useRef();
  useEffect(() => {
    getCountUsuarios();
    getUsuarios();
    API.getSearchFilter("User")
      .then((res) => {
        initializationFilter(res);
        setSelectableFilters(res);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    triggerSearch && handleFiltersChange();
  }, [triggerSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  const initializationFilter = (selectableFilters) => {
    const UsersFilterId = selectableFilters.find(
      (filter) => filter.FilterName === "Nombre y Apellidos"
    )?.FilterId;
    const filtros = [{ FilterId: UsersFilterId }];
    setFilters(filtros);
  };

  const pagination = (page) => {
    return { Page: page, PageSize: USUARIOS_POR_PAGINA };
  };

  const getValidActiveFilters = () => {
    const activeFilters =
      mainFilter === "todos-los-usuarios" ? [filters[0]] : filters;
    const validFilters = activeFilters.filter(
      (filter) => filter.FilterId && filter.FilterValue
    );
    return validFilters;
  };

  const getCountUsuarios = () => {
    setLoadingCount(true);
    let data = {};
    const validActiveFilters = getValidActiveFilters();
    if (validActiveFilters.length) data.Filters = validActiveFilters;

    API.getCountUsers(data)
      .then((res) => {
        setCountUsuarios(res?.count);
        setLoadingCount(false);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  };

  const getUsuarios = (page = 1) => {
    setLoading(true);
    let data = {};
    data.Pagination = pagination(page);
    const validActiveFilters = getValidActiveFilters();
    if (validActiveFilters.length) data.Filters = validActiveFilters;
    data.Sort = sortActive;

    API.getUsers(data)
      .then((res) => {
        if (res) {
          if (page === 1 && res.length === 0) setUsuarios([]);
          if (res.length > 0) {
            if (page === 1) setUsuarios(res);
            else setUsuarios([...usuarios, ...res]);
          }
          if (res.length < USUARIOS_POR_PAGINA) {
            setAllShowed(true);
          }
          setPages(page);
        }
        setLoading(false);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  };

  const handleFiltersChange = () => {
    API.sourceGetCountUsers.cancel();
    API.sourceGetUsers.cancel();
    setAllShowed(false);
    clearTimeout(delayTimer.current);
    delayTimer.current = setTimeout(() => {
      getCountUsuarios();
      getUsuarios();
    }, DELAY_BUSCADOR_USUARIOS);
    setTriggerSearch(false);
  };

  const showMore = () => getUsuarios(pages + 1);

  const showedUsuarios = allShowed
    ? countUsuarios
    : pages * USUARIOS_POR_PAGINA;
  const totalUsuarios = loadingCount
    ? `${USUARIOS_POR_PAGINA}+`
    : countUsuarios;

  const changeMainFilter = (e) => {
    const value = e.target.value;
    if (value === "todos-los-usuarios") setOpenedFilter(false);
    if (value === "filtros") {
      if (filters.length === 1) addFilter();
      setOpenedFilter(true);
    }
    setMainFilter(value);

    const totalValidFilters = filters.filter(
      (filter) => filter.FilterId && filter.FilterValue
    ).length;
    const defaultsFilter = [filters[0]];
    const defaultsValidFilters = defaultsFilter.filter(
      (filter) => filter.FilterId && filter.FilterValue
    ).length;
    if (totalValidFilters !== defaultsValidFilters) setTriggerSearch(true);
  };

  const addFilter = () => {
    const filtros = [...filters];
    filtros.push({ FilterId: "", FilterValue: "" });
    setFilters(filtros);
  };

  const removeFilter = (id) => {
    const filtros = [...filters];
    if (filters.length === 2) {
      changeFieldFilter(1, "");
      setFilters(filtros);
    }
    if (filters.length > 2) {
      filtros.splice(id, 1);
      setFilters(filtros);
      if (filters[id].FilterValue !== "") setTriggerSearch(true);
    }
  };

  const changeFieldFilter = (id, value) => {
    const filtros = [...filters];
    filtros[id].FilterId = value;
    setFilters(filtros);
    if (filtros[id].FilterValue !== "") changeTextFilter(id, "");
  };

  const changeTextFilter = (id, value) => {
    const filtros = [...filters];
    filtros[id].FilterValue = value;
    setFilters(filtros);
    setTriggerSearch(true);
  };

  const sort = (field, value) => {
    setSortActive({
      FieldId: field,
      Order: value,
    });
    setTriggerSearch(true);
  };

  return (
    <S.Container>
      <Loading hidden={!loading} />
      <S.TitleBar>
        Usuarios ({showedUsuarios} de {totalUsuarios})
        {permissions.Users?.edit === 1 && (
          <S.ButtonsContainer>
            <Link to={"/Users/create"}>
              <Button label="Crear" disabled={loading} />
            </Link>
          </S.ButtonsContainer>
        )}
      </S.TitleBar>
      <S.SearchBar>
        <S.SelectSearchBar onChange={changeMainFilter} value={mainFilter}>
          <option value="todos-los-usuarios">Todos los Usuarios</option>
          <option value="filtros">Filtros</option>
        </S.SelectSearchBar>
        {mainFilter === "filtros" && (
          <S.ButtonSearchBar onClick={() => setOpenedFilter(!openedFilter)}>
            Filtros 👁
          </S.ButtonSearchBar>
        )}
        <S.InputSearchBar
          id="searchField"
          placeholder="Buscar por Nombre y Apellidos..."
          value={filters[0].FilterValue || ""}
          onChange={(e) => changeTextFilter(0, e.target.value)}
        />
      </S.SearchBar>
      <S.FilterBars hidden={!openedFilter}>
        {filters.map(
          (filter, index) =>
            index > 0 && (
              <FilterRow
                key={index}
                id={index}
                filter={filter}
                selectableFilters={selectableFilters}
                addFilter={addFilter}
                removeFilter={removeFilter}
                changeFieldFilter={changeFieldFilter}
                changeTextFilter={changeTextFilter}
              />
            )
        )}
      </S.FilterBars>
      <S.Table>
        <thead>
          <tr>
            {TITULOS_COLUMNAS_USUARIOS.map((titulo) => (
              <S.TdThead
                key={titulo.key}
                className={titulo.key === sortActive.FieldId ? "active" : null}
              >
                <S.HeaderColumn>
                  <span>{titulo.label}</span>
                  {titulo.sortable && (
                    <Sort
                      field={titulo.key}
                      sortActive={sortActive}
                      onClick={(value) => sort(titulo.key, value)}
                    />
                  )}
                </S.HeaderColumn>
              </S.TdThead>
            ))}
          </tr>
        </thead>
        <tbody>
          {usuarios.length > 0 &&
            usuarios.map((usuario) => (
              <tr key={usuario.Id}>
                <td title={`${usuario.FirstName} ${usuario.LastName}`}>
                  {usuario.FirstName} {usuario.LastName}
                </td>
                <td title={usuario.UserNameSSO}>
                  <Link to={"/Users/" + usuario.Id}>{usuario.UserNameSSO}</Link>
                </td>
                <td title={usuario.NameGestorExterno}>
                  {usuario.NameGestorExterno}
                </td>
                <td title={usuario.RolId}>{usuario.RolId}</td>
                <td title={usuario.Email}>{usuario.Email}</td>
                <td title={usuario.TeamName}>{usuario.TeamName}</td>
                <td title={usuario.UserStatus}>{usuario.UserStatus}</td>
                <td title={usuario.LastModified}>{usuario.LastModified}</td>
                <td title={usuario.LastLogin}>{usuario.LastLogin}</td>
              </tr>
            ))}
        </tbody>
      </S.Table>
      <S.Pagination>
        <S.More onClick={showMore} disabled={loading || allShowed}>
          {allShowed ? "No hay más usuarios" : "Más usuarios..."}
        </S.More>
      </S.Pagination>
    </S.Container>
  );
};
